import { connect, FormikValues } from 'formik'
import { IntlShape, useIntl } from 'react-intl'
import styled from 'styled-components'
import { string } from 'yup'

import Label from '@/components/Label'
import { FormLabel, Row } from '@/components/StyledComponents'
import { VariableInputContainer } from '@/pages/SpaceAppBuilder/components/StyledComponents'
import VariableAutoComplete from '@/pages/SpaceAppBuilder/components/VariableInputDropdown'
import { useWorkflowFeature } from '@/pages/SpaceAppBuilder/FeaturesPage/WorkflowFeatureContext'
import { FieldTypes, LoopStepData, StepData, Variable } from '@/pages/SpaceAppBuilder/utilities/interfaces'

import messages from './messages'

//<editor-fold desc="Styled Components">
const StyledRow = styled(Row)`
  justify-content: flex-start;
  margin-bottom: 5px;
`
//</editor-fold>

//<editor-fold desc="Interfaces">
type LoopProps = {
  readOnly?: boolean
}
//</editor-fold>

const getValidationSchema = (intl: IntlShape) => {
  return {
    inputVariable: string().required(intl.formatMessage(messages.loopInputVariableRequired))
  }
}

const getInitialValues = (stepData: LoopStepData): StepData => {
  return {
    inputVariable: stepData.inputVariable ?? '',
    loopSteps: stepData.loopSteps ?? []
  }
}
const getLoopOperationHelpUrl = 'https://help.workgrid.com/s/article/Loop'

const LoopOperation = ({ formik, readOnly = false }: LoopProps & FormikValues) => {
  const intl = useIntl()

  const { getVariablesForStep } = useWorkflowFeature()
  const variables = getVariablesForStep()

  const onSelectVariable = (variable: Variable, formikName: string) => {
    formik.setFieldValue(formikName, variable.name)
  }

  return variables?.length > 0 ? (
    <>
      <StyledRow>
        <Label required>{intl.formatMessage(messages.inputVariable)}</Label>
      </StyledRow>
      <VariableInputContainer>
        <VariableAutoComplete
          readOnly={readOnly}
          name="stepData.inputVariable"
          variables={variables}
          validVariableTypes={[FieldTypes.ARRAY, FieldTypes.ANY, FieldTypes.OBJECT]}
          placeholder={intl.formatMessage(messages.loopVar)}
          // @ts-expect-error
          onSelectOption={onSelectVariable}
          showValidationMessage={true}
          required
        />
      </VariableInputContainer>
    </>
  ) : (
    <StyledRow>
      <FormLabel>{intl.formatMessage(messages.loopVarErrorMessage)}</FormLabel>
    </StyledRow>
  )
}

export default connect(LoopOperation)

export { getInitialValues, getValidationSchema, getLoopOperationHelpUrl }
